import React from 'react';
import { motion } from 'framer-motion';
export function ClosingSection() {
  return <section className="bg-[#FAF7F2] py-12 md:py-18 px-5 md:px-12 border-t border-[#C9A96E]/10" data-id="element-1">
      <motion.div initial={{
      opacity: 0,
      y: 40
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.8
    }} className="max-w-3xl mx-auto text-center" data-id="element-2">
        {/* Section Label */}
        <div className="mb-6" data-id="element-3">
          <div className="h-px w-16 bg-[#C9A96E] mx-auto mb-4" data-id="element-4" />
          <span className="text-[#C9A96E] uppercase tracking-[0.2em] text-xs font-medium" data-id="element-5">
            La Verdad
          </span>
        </div>

        {/* Main Statement */}
        <p className="text-xl md:text-2xl lg:text-3xl font-serif text-[#1C1C1C] leading-relaxed mb-5" data-id="element-6">
          Este no es un libro de manualidades.
        </p>

        <p className="text-lg md:text-xl text-[#1C1C1C]/80 leading-relaxed mb-7" data-id="element-7">
          Es tu{' '}
          <span className="font-semibold text-[#1C1C1C]" data-id="element-8">
            mapa para subir de nivel social
          </span>{' '}
          a través de tu hogar.
        </p>

        {/* The Vision */}
        <div className="bg-white border border-[#C9A96E]/20 rounded-xl p-6 md:p-8 shadow-sm" data-id="element-9">
          <p className="text-base md:text-lg text-[#1C1C1C]/80 leading-relaxed mb-4" data-id="element-10">
            Nadie tiene que saber que gastaste $40 en tela de oferta.
          </p>
          <p className="text-lg md:text-xl text-[#1C1C1C] leading-relaxed font-serif" data-id="element-11">
            Cuando tus amigas entren a tu sala y te pregunten:{' '}
            <span className="italic text-[#C9A96E]" data-id="element-12">
              "¿Qué decorador contrataste?"
            </span>
            , tú solo sonreirás.
          </p>
        </div>
      </motion.div>
    </section>;
}